import React from 'react'
import { Label } from './style'

function LabelComponent(props) {
    return (
        <Label>{props.children}</Label>
    )
}

export default LabelComponent


// WEBPACK FOOTER //
// ./src/SPRINTA/v3/Form/Label.js